module.exports = "https://coursera_assets.s3.amazonaws.com/images/40c2f71146a66f013df9f88d32443cff.png";